/**
 * Счётчики поставщиков тендера для вкладки «Аналитика тендеров».
 * В «Со ставкой», «Отказались» и «Без ставки» поставщик попадает только один раз: ставка важнее отказа.
 */
class TenderSuppliersStats {

  /** Одобрены на товар тендера */
  public approvedCount: number;

  /** Одобрены, не исключены из торгов, сырьё доступно */
  public availableCount: number;

  /** Есть хотя бы одна ставка, одобрение не проверяется */
  public withBidCount: number;

  /** Ставок нет, есть отказ хотя бы по одному разрешению */
  public refusedCount: number;

  /** Доступны, ставок и отказов нет */
  public withoutBidCount: number;

  static fromServer(data: any): TenderSuppliersStats {
    const result = new TenderSuppliersStats();

    result.approvedCount   = data.approvedCount;
    result.availableCount  = data.availableCount;
    result.withBidCount    = data.withBidCount;
    result.refusedCount    = data.refusedCount;
    result.withoutBidCount = data.withoutBidCount;

    return result;
  }
}

export default TenderSuppliersStats;
